import { AllocationGridColumns } from "components/product-collection/product-collection-views/product-collection-grid-view/detail-list/helpers";
import {
    Item as ProductDisplayFieldPaths,
    MANUFACTURED_SIZES_DELIMITER,
    NRF_DELIMITER,
    UPC_DELIMITER,
} from "constants/product-collection";
import { Map } from "immutable";
import { parseSelectedSizes, sizeManufacturedGetter } from "./product-collection";
export const mapByIndexGeneric = (size: any, lookupArray: any[], mappingArray: any[]) =>
    mappingArray[lookupArray.indexOf(size)];
export const mapByIndex = (size: string, manufacturedSizes: string[], mappingArray: string[]) =>
    mapByIndexGeneric(size, manufacturedSizes, mappingArray);

export const itemHasEmptyUPCsorNRFs = (item: Map<string, any>) => {
    const selectedSizesString = item.getIn(ProductDisplayFieldPaths.FIELDS.SIZES_SELECTED, "");
    const selectedSizes = parseSelectedSizes(selectedSizesString)?.allSizes;
    const vendorSizesString = sizeManufacturedGetter(null, { data: item?.toJS() });
    const vendorSizes = (vendorSizesString || "").split(MANUFACTURED_SIZES_DELIMITER);
    const upcs = getDelimitedSizeValues(item, ProductDisplayFieldPaths.FIELDS.UPC, UPC_DELIMITER);
    const nrfs = getDelimitedSizeValues(item, ProductDisplayFieldPaths.FIELDS.NRF_SIZE_CODE, NRF_DELIMITER);
    if (!selectedSizes?.length) {
        return { nrf: false, upc: false };
    }
    return selectedSizes.reduce(
        (acc, size) => ({
            nrf: acc.nrf || !mapByIndex(size, vendorSizes, nrfs),
            upc: acc.upc || !mapByIndex(size, vendorSizes, upcs),
        }),
        { nrf: false, upc: false }
    );
};

export const getDelimitedSizeValues = (item: Map<string, any>, field: string[], delimiter: string) =>
    item?.getIn(field)?.split(delimiter) ?? [];
export const expandValueArray = (prevValues: string[], index: number, newValue: string | number) => {
    if (!(index in prevValues)) {
        prevValues = prevValues.concat(Array(index - prevValues.length + 1).fill(""));
    }
    prevValues[index] = `${newValue ?? ""}`; // Cast to string.
    return prevValues;
};

export const getDelimiterForSizeLevelColumn = (column: string) =>
    ({
        [AllocationGridColumns.UPC]: UPC_DELIMITER,
        [AllocationGridColumns.NRFSizeCode]: NRF_DELIMITER,
        [AllocationGridColumns.NRFSizeDescription]: NRF_DELIMITER,
    })[column];
export const delimitedFieldHasSingleValue = (fieldValue: string, delimiter: string) =>
    (!!fieldValue && !fieldValue.includes(delimiter)) ||
    fieldValue.split(delimiter).every((chunk, i) => (i === 0 && !!chunk) || (i > 0 && !chunk));
